import React, {useEffect, useState} from "react";
import Config from "../Config";
import token from "../AuthToken";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import _ from "../Trans";
import Currency from "./Currency";
import BarLoader from "react-spinners/BarLoader";
import ReactGA from "react-ga4";

export default function SquadFinance({squad, show, setShow}) {
    const [alreadyFetched, setAlreadyFetched] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [barLoader, setBarLoader] = useState(false);

    useEffect(() => fetchFinance(), [show]); // eslint-disable-line

    const toggle = function() {
        if(!show && !alreadyFetched) {
            try {
                ReactGA.event({
                    category: "finance",
                    action: "view",
                    label: "finance"
                })
            }
            catch(e) {
                console.error(e)
            }
            fetchFinance();
        }
        setShow(!show);
    }

    const hide = function() {
        setShow(false);
    }

    useEffect(() => setAlreadyFetched(true), [modalData]);

    const fetchFinance = function() {
        if(!show) {
            return;
        }
        setBarLoader(true);
        const url = Config.financeUrl.replace('/0/', '/'+squad.id+'/');
        try {
            fetch(url, {
                headers: {
                    Authorization: 'Token ' + token,
                    'Content-Type': 'application/json'
                }
            })
                .then((e) => {
                    if (e.status < 300) {
                        return Promise.resolve(e.json())
                    }
                    return Promise.reject(e)
                })
                .then(e => setModalData(e))
                .finally(() => setBarLoader(false))
        } catch(e) {
            console.log(e);
        }
    }

    let tdStyle = {
        border: 0
    }
    const closeText = _('Close')

    let playerTable = (
        <table className="table table-striped">
        <thead>
        <tr>
            <th className="text-left">{_('Player')}</th>
            <th className="text-right">{_('Date')}/{_('Price')}</th>
        </tr>
        </thead>
        <tbody>
        {modalData?.transactions.map(transaction => <Transaction key={transaction.id} transaction={transaction}/>)}
        </tbody>
        </table>
    )

    return (
        <Modal isOpen={show} toggle={toggle} id="squad-finance" tabIndex="-1" role="dialog" fade={false}>
            <ModalHeader>
                <div className="d-flex justify-content-between w-100">
                    <div id="exampleModalLabel" className="font-weight-bold h4">{_('Team finances')}</div>
                    <div className="float-right mt-1">
                        <button onClick={toggle} type="button"
                                className="close float-right text-right"
                                data-dismiss="modal" aria-label={closeText}>
                          <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody>
            {modalData?.id === null || modalData?.id === undefined ?
                (
                <div className="w-100 d-flex justify-content-center">
                    <BarLoader
                        color="#23a6da"
                        loading={barLoader}
                        width={400}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
                )
                :
                (
                <div>
                <table className='table w-100 font-weight-bold h5'>
                    <tbody>
                        <tr>
                            <td style={tdStyle}>{_('Team budget')}</td><td align='right' style={tdStyle}> <Currency value={modalData?.budget}/></td>
                        </tr>
                        <tr>
                            <td style={tdStyle}>{_('Current value')}</td><td align='right' style={tdStyle}> <Currency value={modalData?.current_value}/></td>
                        </tr>
                    </tbody>
                </table>
                </div>
                )
            }
                {false && playerTable}
            </ModalBody>
            <ModalFooter>
                  <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={hide}>
                      {_('Close')}
                  </button>
            </ModalFooter>
        </Modal>
    )
}

function Transaction({transaction}) {
    return (
        <tr>
            <td style={{'text-overflow': 'ellipsis', 'overflow': 'hidden', 'white-space': 'nowrap'}}>{transaction.name}</td>
            <td className="text-right">
                {transaction.history_date}
                <br/>
                <Currency value={transaction.buy_price} color="green"/>
            </td>
        </tr>
    )
}